import { Button } from "../ui/button";
import { DialogClose, DialogFooter } from "../ui/dialog";

type DocumentDialogFooterProps = {
  onConfirm: () => void;
  confirmLabel: string;
  confirmLoadingLabel?: string;
  cancelLabel?: string;
  disabled?: boolean;
  loading?: boolean;
  onCancel?: () => void;
};

export function DocumentDialogFooter({
  onCancel,
  onConfirm,
  confirmLabel,
  confirmLoadingLabel,
  cancelLabel = "Cancel",
  disabled = false,
  loading = false,
}: DocumentDialogFooterProps) {
  const handleCancel = () => {
    onCancel?.();
  };

  const getConfirmLabel = () => {
    if (loading) {
      return confirmLoadingLabel || confirmLabel;
    }
    return confirmLabel;
  };

  return (
    <DialogFooter>
      <DialogClose asChild>
        <Button variant="outline" size="sm" onClick={handleCancel}>
          {cancelLabel}
        </Button>
      </DialogClose>
      <Button size="sm" onClick={onConfirm} disabled={disabled || loading}>
        {getConfirmLabel()}
      </Button>
    </DialogFooter>
  );
}
